module.exports = __webpack_public_path__ + "r-v3/img/ml_30_00.4ce8c733.jpg";